export const VERSION_COMPRARTODO = "1.0.3";